/**
 * Hub Medical
 * Hub medical Consorcio
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserPreferenceDTO { 
    id?: number;
    preferenceType?: UserPreferenceDTO.PreferenceTypeEnum;
    displayName?: string;
    description?: string;
    enabled?: boolean;
    preferenceValue?: string;
}
export namespace UserPreferenceDTO {
    export type PreferenceTypeEnum = 'AUTO_SHARE_DOCUMENTS' | 'EMAIL_NOTIFICATIONS' | 'SMS_NOTIFICATIONS' | 'AUTO_ACCEPT_NEGOTIATIONS' | 'PROFILE_VISIBILITY' | 'DATA_SHARING_CONSENT' | 'MARKETING_COMMUNICATIONS';
    export const PreferenceTypeEnum = {
        AutoShareDocuments: 'AUTO_SHARE_DOCUMENTS' as PreferenceTypeEnum,
        EmailNotifications: 'EMAIL_NOTIFICATIONS' as PreferenceTypeEnum,
        SmsNotifications: 'SMS_NOTIFICATIONS' as PreferenceTypeEnum,
        AutoAcceptNegotiations: 'AUTO_ACCEPT_NEGOTIATIONS' as PreferenceTypeEnum,
        ProfileVisibility: 'PROFILE_VISIBILITY' as PreferenceTypeEnum,
        DataSharingConsent: 'DATA_SHARING_CONSENT' as PreferenceTypeEnum,
        MarketingCommunications: 'MARKETING_COMMUNICATIONS' as PreferenceTypeEnum
    };
}


